import React, { useRef } from 'react';
import s from '../ProductsByCategory/ProductsByCategory.module.scss';
import { ReactComponent as ArrowDown } from 'images/new-icons/arrow-down-gray.svg';
import { useTranslation } from 'react-i18next';

interface StoreFilterProps {
    selectedStore: string;
    setSelectedStore: (value: string) => void;
    showStoresDropdown: boolean;
    setShowStoresDropdown: (value: boolean) => void;
    stores: Array<{ id: number; store_name: string }>;
}

const StoreFilter: React.FC<StoreFilterProps> = ({
                                                     selectedStore,
                                                     setSelectedStore,
                                                     showStoresDropdown,
                                                     setShowStoresDropdown,
                                                     stores,
                                                 }) => {
    const dropdownRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation() as any;

    return (
        <div className={s.filter} ref={dropdownRef}>
            <div className={s.filter_item} onClick={() => setShowStoresDropdown(!showStoresDropdown)}>
                <span>{selectedStore === 'All' ? t('All Stores') : selectedStore}</span>
                <ArrowDown className={showStoresDropdown ? s.rotate : ''} />
            </div>
            {showStoresDropdown && (
                <div className={s.dropdown}>
                    <div
                        className={s.dropdown_item}
                        onClick={() => {
                            setSelectedStore('All');
                            setShowStoresDropdown(false);
                        }}
                    >
                        {t('All Stores')}
                    </div>
                    {stores?.map(store => (
                        <div
                            key={store.id}
                            className={s.dropdown_item}
                            onClick={() => {
                                setSelectedStore(store.store_name);
                                setShowStoresDropdown(false);
                            }}
                        >
                            {store.store_name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StoreFilter;